function descriptorItemController(userService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.editMode = false;
    ctrl.updateStatusList();
    ctrl.hasEditDescriptors = userService.hasEditDescriptors();
    ctrl.hasAutoUpload = __env.profile === 'LU'
  };

  ctrl.updateStatusList = () => {
    ctrl.statusList = [
      { id: 0, type: 'Sanctioned', disabled: ctrl.sanctionedExists && ctrl.descriptorData.type !== "AVI_DB"},
      { id: 1, type: 'Engineering', disabled: ctrl.engineeringExists && ctrl.descriptorData.type !== "AVI_DB" },
      { id: 2, type: 'Valid', disabled: ctrl.validExists && ctrl.descriptorData.type !== "AVI_DB" },
      { id: 3, type: 'Deprecated', disabled: false }
    ];
  }

  ctrl.$onChanges = changes => {
    if (changes.data) {
      ctrl.descriptorData = angular.copy(ctrl.data);
      ctrl.oldStatus = ctrl.descriptorData.status;
    }
   
    ctrl.updateStatusList();
  };

  ctrl.enableEdit = () => {
    ctrl.editMode = true;
  };

  ctrl.saveDescriptor = () => {
    ctrl.editMode = false;
    if (ctrl.oldStatus !== ctrl.descriptorData.status) {
      ctrl.onUpdate({
        $event: {
          descriptor: ctrl.descriptorData,
        },
      });
    }
  };

  ctrl.removeDescriptor = () => {
    ctrl.onDelete({
      $event: {
        descriptor: ctrl.descriptorData,
        type: ctrl.type, // TODO: Remove this and add revision type into descriptor object?
      },
    });
  };
}

angular
  .module('configuration-management.module')
  .controller('descriptorItemController', descriptorItemController);
